// src/utils/splitText.js
export const splitText = (text, length) => {
  const TextSize = text?.length;
  if (TextSize > length) {
    return text.slice(0, length) + '...';
  } else {
    return text;
  }
  };
  